import { Link, useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export function Header() {
  const { settings } = useSettings();
  const loc = useLocation();
  const links = [
    { to: "/", label: "Ana Sayfa" },
    { to: "/siparis-ver", label: "Sipariş Ver" },
    { to: "/siparis-takip", label: "Sipariş Takip" },
    { to: "/blog", label: "Blog" },
    { to: "/iletisim", label: "İletişim" },
  ];
  return (
    <header className="hidden md:block sticky top-0 z-40 glass border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <nav className="flex items-center gap-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.to}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "text-white bg-white/10" : "text-gray-400 hover:text-white hover:bg-white/5"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <a href={settings?.support_url || "#"} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 bg-white text-[#1f222d] font-semibold text-sm px-5 py-2.5 rounded-full hover:scale-[1.03] transition-transform"
          data-testid="header-support-btn">
          <MessageCircle size={16} className="text-green-600" /> Destek
        </a>
      </div>
    </header>
  );
}
